import { getAssociatedStations } from '../../actions/contentActions'

const isValidIPv4 = (ip) => {
  const regex =
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  return regex.test(ip)
}

const fetchIP = async () => {
  return getAssociatedStations().then(
    (response) => response && response['ip_address']
  )
}

const formatIpV4Address = (ip) => {
  const parts = ip.split('.')
  return `P${parts[0]}-B${parts[1]}-S${parts[2]}-V${parts[3]}`
}

export const getSupportCode = async () => {
  const ip = await fetchIP()
  if (isValidIPv4(ip)) {
    return formatIpV4Address(ip)
  }
  return ''
}
